import { NgModule } from "@angular/core";

import { TaskCreateModule } from "./create/create-task.module";
import { TaskOverviewModule } from "./task-overview/task-overview.module";
import { TasksDetailModule } from "./detail/tasks-detail.module";
import { TaskOptionsModule } from "./options/task-options.module";
import { SharedModule } from "../shared/shared.module";
import { routing } from "./tasks.routing";

import { NotFoundComponent } from "./not-found/not-found.component";

@NgModule({
	imports: [SharedModule, TaskOverviewModule, TasksDetailModule, TaskOptionsModule, TaskCreateModule],
	exports: [TaskOverviewModule, TasksDetailModule, TaskOptionsModule, TaskCreateModule],
})
export class TasksSharedModule {}

@NgModule({
	imports: [SharedModule, TasksSharedModule, routing],
	declarations: [NotFoundComponent],
})
export class TasksModule {}
